export default __webpack_public_path__ + "static/media/cp_geo_tc.f74ae43b.svg";